import { Link } from '@buzola/router'
import { memo, type PropsWithChildren, type ReactNode } from 'react'
import { LayoutComponent, Slots } from '~/lib/layout'
import { UserNavigation } from './navigation'

export type ShellProps = PropsWithChildren<{
	navigation: ReactNode
	logoText?: string
}>

export const Wordmark = ({ subtitle }: { subtitle?: string }) => (
	<span className="flex items-baseline gap-1.5 leading-none">
		<span className="font-display italic text-2xl tracking-tight">roj</span>
		<span aria-hidden className="size-1 rounded-full bg-foreground translate-y-[-3px]" />
		{subtitle && (
			<span className="text-[10px] font-mono uppercase tracking-[0.18em] text-muted-foreground translate-y-[-2px]">
				{subtitle}
			</span>
		)}
	</span>
)

export const Shell = memo(({ navigation, logoText, children }: ShellProps) => {
	return (
		<LayoutComponent>
			<Slots.Logo>
				<Link to="app">
					<Wordmark subtitle={logoText ?? 'cloud'} />
				</Link>
			</Slots.Logo>

			<Slots.Navigation>{navigation}</Slots.Navigation>

			<Slots.UserNavigation>
				<UserNavigation />
			</Slots.UserNavigation>

			{children}
		</LayoutComponent>
	)
})
Shell.displayName = 'Shell'
